import type { EventDayShape, LayoutMode } from '@classic/Components/EventsSlider/Types';

// Represents the different slider configurations
export const SLIDER_CONFIGURATIONS = {
    FOUR_EVENTS: 'four-events',
    FOUR_EVENTS_FACEBOOK_FEED: 'four-events-facebook-feed',
    FOUR_EVENTS_FULL_CALENDAR: 'four-events-full-calendar',
    MEAL_EVENTS_GRID: 'meal-events-grid',
    SIX_EVENTS: 'six-events',
    FOUR_EVENTS_STACKED: 'four-events-stacked',
    SIX_EVENTS_STACKED: 'six-events-stacked',
};

export type SliderConfiguration = typeof SLIDER_CONFIGURATIONS[keyof typeof SLIDER_CONFIGURATIONS];

export interface EventSliderConfiguration {
    calendarId: number;
    cssVariables: Record<string, string>;
    sliderConfiguration: SliderConfiguration;
    displayEvents: number;
    originationDate: Date;
    layoutMode: LayoutMode;
    eventDayShape: EventDayShape;
    isMealCalendar: boolean;
}
